import { formatCurrency } from 'fitify-utils/src/number/format-number'

import type { SubscriptionPlan } from '../types/subscription'

export const getCurrencyDenominator = (currencyCode: string): number => {
  const formatter = new Intl.NumberFormat('en', {
    style: 'currency',
    currency: currencyCode,
  })
  const fractionDigits = formatter.resolvedOptions().minimumFractionDigits
  return Math.pow(10, fractionDigits || 0)
}

export const getPlanWeeksCount = (
  plan: Pick<SubscriptionPlan, 'intervalLength' | 'intervalUnit'>
): number => {
  if (typeof plan.intervalLength === 'number') {
    switch (plan.intervalUnit) {
      case 'day':
        return Math.round(plan.intervalLength / 7)
      case 'week':
        return plan.intervalLength
      case 'month':
        return plan.intervalLength * 4
      case 'year':
        return plan.intervalLength * 52
      default:
        return 0
    }
  }
  return 0
}

const getPlanDaysCount = (
  plan: Pick<SubscriptionPlan, 'intervalLength' | 'intervalUnit'>
): number => {
  if (typeof plan.intervalLength === 'number') {
    switch (plan.intervalUnit) {
      case 'day':
        return plan.intervalLength
      case 'week':
        return plan.intervalLength * 7
      case 'month':
        return plan.intervalLength * 30
      case 'year':
        return plan.intervalLength * 365
      default:
        return 0
    }
  }
  return 0
}

export const getPlanMonthsCount = (
  plan: Pick<SubscriptionPlan, 'intervalLength' | 'intervalUnit'>
): number => {
  if (typeof plan.intervalLength === 'number') {
    switch (plan.intervalUnit) {
      case 'day':
        return plan.intervalLength / 30
      case 'week':
        return plan.intervalLength / 4
      case 'month':
        return plan.intervalLength
      case 'year':
        return plan.intervalLength * 12
      default:
        return 0
    }
  }
  return 0
}

export const getPricePerDay = (
  value: number,
  plan: Pick<
    SubscriptionPlan,
    'currency' | 'intervalLength' | 'intervalUnit' | 'locale'
  >
): string => {
  const daysCount = getPlanDaysCount({
    intervalLength: plan.intervalLength,
    intervalUnit: plan.intervalUnit,
  })
  const pricePerDay = daysCount > 0 ? value / daysCount : 0

  return formatCurrency(pricePerDay, plan.currency, plan.locale)
}

export const getDiscountDurationInDays = (
  plan: Pick<
    SubscriptionPlan,
    'discountDurationLength' | 'discountDurationUnit'
  >
) => {
  if (typeof plan.discountDurationLength === 'number') {
    switch (plan.discountDurationUnit) {
      case 'day':
        return plan.discountDurationLength
      case 'week':
        return plan.discountDurationLength * 7
      case 'month':
        return plan.discountDurationLength * 30
      case 'year':
        return plan.discountDurationLength * 365
      default:
        return 0
    }
  }
  return 0
}
